import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {competencyById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import ThemeProvider from './ThemeProvider';

export default connect(
  createStructuredSelector({
    currentUserCompetency: withProps({coachId: userId})(competencyById),
  }),
)(ThemeProvider);
